import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Card, Form, Container, Table, Badge as BsBadge, Button, Tooltip, OverlayTrigger, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import Pagination from 'react-js-pagination';
import * as moment from 'moment';
import { HOSO_TUYENSINH_API } from '@app/utils/apiUrl';
import { Get, DeleteSingle, Put } from '@app/utils/httpProvider';
import { toast } from 'react-toastify';
import { createUrlWithParam } from '../../../../../utils/helper';
import { URI_INTERNAL } from '../../../../../utils/pathLocations';
import { userManager } from '@app/utils/oidc';
import { 
    trangThaiHoSoDuTuyenValue,
    objectTrangThaiHoSoDuTuyen,
    objectShowNumber
} from '../../../../../utils/define';
import HoSoTuyenSinhDetailModal from './HoSoTuyenSinhDetailModal';
import DangKyHoSoModal from './DangKyHoSoModal';
import { ConfirmModal } from '../../../../../modules/modal/ConfirmModal';
import DocumentInput from '../../../../../components/document-input/DocumentInput';
// import qrImage from '../../../../../assets/QRnhantien.jpg';
import qrImage from '../../../../../assets/QRtien.png';

const HoSoTuyenSinh = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');
    const [accountId, setAccountId] = useState('');
    
    // Modal states
    const [showDetail, setShowDetail] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [selectedHoSoId, setSelectedHoSoId] = useState(null);
    const [selectedDotTuyenSinhId, setSelectedDotTuyenSinhId] = useState(null);
    
    // Delete Confirm Modal states
    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [openConfirmSubmitModal, setOpenConfirmSubmitModal] = useState(false);
    const [appToSubmit, setAppToSubmit] = useState(null);
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    // QR Modal state
    const [showQRModal, setShowQRModal] = useState(false);
    const [fileMinhChungLePhi, setFileMinhChungLePhi] = useState('');

    useEffect(() => {
        const fetchInfo = async () => {
            const user = await userManager.getUser();
            const accId = user?.profile?.sub || null;
            if (accId) setAccountId(accId);
        };
        fetchInfo();
    }, []);

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (paramUrl.get('page') != null && parseInt(paramUrl.get('page'), 10) !== page) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (paramUrl.get('size') != null && parseInt(paramUrl.get('size'), 10) !== pageSize) {
        setPageSize(parseInt(paramUrl.get('size'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    const replaceHistory = (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.HOSOTUYENSINH_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['myApplications', accountId, valueSearch, page, pageSize],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize,
                AccountId: accountId
            };
            replaceHistory(page, pageSize, valueSearch);
            return Get(HOSO_TUYENSINH_API.GET_PAGING, null, model);
        },
        {
            enabled: !!accountId,
            keepPreviousData: true
        }
    );

    useEffect(() => {
        if (accountId) {
            refetch();
        }
    }, [pageSize, page, accountId]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search && accountId) {
            setPage(1);
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch, accountId]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search);
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined) return '';
        const actualValue = typeof value === 'string' && valueMap ? valueMap[value] : value;
        const found = objectEnum.find((item) => item.value === actualValue);
        return found ? found.label : '';
    };

    const handleViewDetail = (app) => {
        setSelectedHoSoId(app.id || app.Id);
        setShowDetail(true);
    };

    const handleEdit = (app) => {
        setSelectedHoSoId(app.id || app.Id);
        setSelectedDotTuyenSinhId(app.dotTuyenSinhId || app.DotTuyenSinhId);
        setShowEdit(true);
    };

    const handleDelete = (app) => {
        setIdWantDelete(app.id || app.Id);
        setConfirmDelMessage(app.soHoSo || app.SoHoSo || 'hồ sơ này');
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (!idWantDelete) return;
        try {
            const res = await DeleteSingle(HOSO_TUYENSINH_API.DELETE_ITEM, idWantDelete);
            if (res && res.ok) {
                toast.success('Xóa hồ sơ thành công');
                refetch();
            } else {
                toast.error('Có lỗi xảy ra khi xóa hồ sơ');
            }
        } catch (error) {
            toast.error(error?.message || 'Có lỗi xảy ra khi xóa hồ sơ');
        }
        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    const handleNextStep = (app) => {
        setSelectedHoSoId(app.id || app.Id);
        setFileMinhChungLePhi(app.fileMinhChungLePhi || app.FileMinhChungLePhi || '');
        setShowQRModal(true);
    };

    const handleSaveFile = async () => {
        if (!selectedHoSoId) return;
        try {
            const res = await Get(HOSO_TUYENSINH_API.GET_ITEM, selectedHoSoId);
            if (res) {
                let fullItem = res.data ? res.data : res; 
                fullItem.fileMinhChungLePhi = fileMinhChungLePhi;
                const updateRes = await Put(HOSO_TUYENSINH_API.UPDATE_ITEM, selectedHoSoId, fullItem);
                if (updateRes && updateRes.ok) {
                    toast.success('Lưu file minh chứng thành công');
                    setShowQRModal(false);
                    refetch();
                } else {
                    toast.error('Có lỗi xảy ra khi lưu file');
                }
            } else {
                toast.error('Không lấy được dữ liệu hồ sơ');
            }
        } catch (error) {
            toast.error('Có lỗi xảy ra khi lưu file');
            console.error(error);
        }
    };

    const handleTriggerSubmit = (app) => {
        setAppToSubmit(app);
        setOpenConfirmSubmitModal(true);
    };

    const confirmSubmitHoSo = async () => {
        if (!appToSubmit) return;
        const id = appToSubmit.id || appToSubmit.Id;
        setOpenConfirmSubmitModal(false);
        try {
            const res = await Get(HOSO_TUYENSINH_API.GET_ITEM, id);
                if (res) {
                    let fullItem = res.data ? res.data : res; 
                    fullItem.trangThaiHoSoDuTuyen = trangThaiHoSoDuTuyenValue.choDuyet;
                    fullItem.TrangThaiHoSoDuTuyen = trangThaiHoSoDuTuyenValue.choDuyet;
                    
                    const updateRes = await Put(HOSO_TUYENSINH_API.UPDATE_ITEM, id, fullItem);
                    if (updateRes && updateRes.ok) {
                        toast.success('Gửi hồ sơ thành công');
                        refetch();
                    } else {
                        toast.error('Có lỗi xảy ra khi gửi hồ sơ');
                    }
                } else {
                    toast.error('Không lấy được dữ liệu hồ sơ');
                }
            } catch (error) {
                toast.error('Có lỗi xảy ra khi gửi hồ sơ');
                console.error(error);
            }
    };

    return (
        <div className="container-fluid">
            <Card>
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <h5>Hồ sơ tuyển sinh của tôi</h5>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Số hồ sơ</th>
                                    <th>Đợt tuyển sinh</th>
                                    <th>Ngày nộp</th>
                                    <th className="text-center">Trạng thái</th>
                                    <th className="text-center" style={{ width: '120px' }}>Thao tác</th>
                                    <th className="text-center" style={{ width: '180px' }}>Gửi hồ sơ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={6}>Đang tải...</td>
                                    </tr>
                                ) : isError ? (
                                    <tr>
                                        <td colSpan={6}>Lỗi: {error?.message || 'Không tải được dữ liệu'}</td>
                                    </tr>
                                ) : items.length === 0 ? (
                                    <tr>
                                        <td colSpan={6}>Bạn chưa có hồ sơ đăng ký tuyển sinh nào.</td>
                                    </tr>
                                ) : (
                                    items.map((app, idx) => {
                                        const statusLabel = getLabelFromEnum(app.trangThaiHoSoDuTuyen ?? app.TrangThaiHoSoDuTuyen, objectTrangThaiHoSoDuTuyen, trangThaiHoSoDuTuyenValue);
                                        const cDate = app.createdDate || app.CreatedDate;
                                        const dateStr = cDate ? moment(cDate).format('DD/MM/YYYY HH:mm') : '';
                                        return (
                                            <React.Fragment key={app.id || idx}>
                                                <tr>
                                                    <td className="font-weight-bold text-primary">{app.soHoSo || app.SoHoSo || 'Chưa cấp'}</td>
                                                    <td>{app.tenDotTuyenSinh || app.TenDotTuyenSinh}</td>
                                                    <td>{dateStr}</td>
                                                    <td className="text-center">
                                                        <BsBadge 
                                                            variant={
                                                                statusLabel === 'Duyệt' ? 'success' :
                                                                statusLabel === 'Từ chối' ? 'danger' :
                                                                statusLabel === 'Cần chỉnh sửa' ? 'warning' : 'info'
                                                            } 
                                                            className="px-3 py-2"
                                                            style={{ borderRadius: '20px' }}
                                                        >
                                                            {statusLabel}
                                                        </BsBadge>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="d-flex justify-content-center">
                                                            <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-view-${idx}`}>Xem chi tiết</Tooltip>}>
                                                                <Button variant="outline-info" size="sm" className="mr-2" onClick={() => handleViewDetail(app)}>
                                                                    <i className="fa fa-eye"></i>
                                                                </Button>
                                                            </OverlayTrigger>
                                                            <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-edit-${idx}`}>Sửa</Tooltip>}>
                                                                <Button variant="outline-warning" size="sm" className="mr-2" onClick={() => handleEdit(app)}>
                                                                    <i className="fa fa-edit"></i>
                                                                </Button>
                                                            </OverlayTrigger>
                                                            <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-delete-${idx}`}>Xóa</Tooltip>}>
                                                                <Button variant="outline-danger" size="sm" onClick={() => handleDelete(app)}>
                                                                    <i className="fa fa-trash"></i>
                                                                </Button>
                                                            </OverlayTrigger>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        {(statusLabel === 'Chờ gửi' || statusLabel === 'Cần chỉnh sửa') ? (
                                                            <Button variant="primary" size="sm" onClick={() => handleTriggerSubmit(app)}>
                                                                <i className="fas fa-paper-plane mr-1"></i> Gửi đi
                                                            </Button>
                                                        ) : (
                                                            <Button variant="secondary" size="sm" disabled>
                                                                <i className="fas fa-paper-plane mr-1"></i> Gửi đi
                                                            </Button>
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="6" className="p-0 border-0">
                                                        <div className="d-flex align-items-center p-3" style={{ backgroundColor: '#f0fdf4', borderLeft: '4px solid #22c55e', borderBottom: '1px solid #e2e8f0' }}>
                                                            <div className="d-flex align-items-center" style={{ flexBasis: '50%' }}>
                                                                <div className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center mr-3 shadow-sm" style={{ width: '45px', minWidth: '45px', height: '45px', fontSize: '1.25rem' }}>
                                                                    <i className="fas fa-file-invoice-dollar"></i>
                                                                </div>
                                                                <div>
                                                                    <h6 className="mb-1 font-weight-bold text-success" style={{ fontSize: '1.1rem' }}>Bước 2: Hoàn tất lệ phí xét tuyển</h6>
                                                                    <span className="text-muted small">Vui lòng quét mã QR để thanh toán và tải lên minh chứng để hoàn thành hồ sơ.</span>
                                                                </div>
                                                            </div>
                                                            <div className="ml-4 text-center" style={{ flexBasis: '25%' }}>
                                                                <Button variant="success" onClick={() => handleNextStep(app)} className="px-5 py-2 font-weight-bold shadow-sm d-inline-flex align-items-center" style={{ borderRadius: '30px', transition: 'all 0.3s ease' }}>
                                                                    <i className="fas fa-qrcode mr-2" style={{ fontSize: '1.2rem' }}></i> Đóng lệ phí
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        );
                                    })
                                )}
                            </tbody>
                        </Table>
                    </div>

                    {/* 
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div>
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                innerClass="pagination pagination-sm no-margin"
                                activePage={page}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                            />
                        </div>
                    </div>
                    */}
                </Card.Body>
            </Card>

            {showDetail && (
                <HoSoTuyenSinhDetailModal 
                    show={showDetail} 
                    handleClose={() => {
                        setShowDetail(false);
                        setSelectedHoSoId(null);
                    }} 
                    hoSoId={selectedHoSoId} 
                />
            )}

            {showEdit && (
                <DangKyHoSoModal
                    show={showEdit}
                    handleClose={() => {
                        setShowEdit(false);
                        setSelectedHoSoId(null);
                        setSelectedDotTuyenSinhId(null);
                        refetch();
                    }}
                    hoSoId={selectedHoSoId}
                    dotTuyenSinhId={selectedDotTuyenSinhId}
                />
            )}

            <ConfirmModal
                isOpen={openConfirmDeleteModal}
                confirmType="delete"
                handleAccept={acceptDelete}
                handleCancel={cancelDelete}
                content={confirmDelMessage}
            />

            <ConfirmModal
                isOpen={openConfirmSubmitModal}
                handleAccept={confirmSubmitHoSo}
                handleCancel={() => setOpenConfirmSubmitModal(false)}
                content="Bạn có chắc chắn muốn gửi hồ sơ này đi để xét duyệt không?"
                labelAccept="Gửi đi"
            />

            <Modal show={showQRModal} onHide={() => setShowQRModal(false)} centered contentClassName="bg-white" style={{ zIndex: 9999 }}>
                <Modal.Header closeButton className="bg-primary text-white border-bottom-0">
                    <Modal.Title><i className="fas fa-qrcode mr-2"></i> Quét mã để chuyển tiền</Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-white p-3">
                    <div className="text-center mb-3">
                        <div className="bg-white p-2 rounded shadow-sm d-inline-block border" style={{ width: '100%', maxWidth: '380px' }}>
                            <img src={qrImage} alt="QR Nhận tiền" className="img-fluid" style={{ width: '100%', height: 'auto', objectFit: 'contain' }} />
                        </div>
                    </div>
                    <div className="mt-4 border-top pt-3">
                        <DocumentInput
                            title="File minh chứng lệ phí"
                            labelTitle="Tải lên file minh chứng lệ phí"
                            name="fileMinhChungLePhi"
                            value={fileMinhChungLePhi}
                            onChangeProp={(val) => setFileMinhChungLePhi(val)}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top-0 justify-content-center">
                    <Button variant="outline-secondary" onClick={() => setShowQRModal(false)} className="px-4">
                        Đóng
                    </Button>
                    <Button variant="primary" onClick={handleSaveFile} className="px-4">
                        <i className="fas fa-save mr-2"></i> Lưu file
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default HoSoTuyenSinh;
